/* =====================================================================
   mw-personalize.js — the personalisation panel.
   ---------------------------------------------------------------------
   Builds the fields from MW_PERSONALIZE (generated from ccd-data.js),
   shows the customer's words in the lettering they pick, adds up what
   they have chosen, and hands the finished thing to MW.addToCart.

   THE PRICE

       total = the Shopify variant price (size / shape / material,
               owned by the theme's own option buttons)
             + the engraving fee, but only when there is text
             + each extra that is ticked
             + a per-character fee past the free allowance, where the
               product has one (word cutouts)

   The variant price is read from the theme's hidden variant field, so
   whatever Shopify charges for the variant is what this panel adds to.
   There is no second price list.

   WHAT IT DOES NOT DO
   It does not draw the piece. The gallery above it is photographs of
   real work, and the proof Todd sends is the layout. The sample here
   is lettering, labelled as lettering.
===================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.mw-personalize');
  if (!root) return;

  var handle = root.getAttribute('data-handle');
  var cfg = (window.MW_PERSONALIZE || {})[handle];
  var map = (function () {
    var el = document.getElementById('mw-variant-map');
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();
  if (!cfg || !map) return;

  var $ = function (name) { return root.querySelector('[data-mw="' + name + '"]'); };
  var esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };
  var money = function (n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); };

  /* ---- build the fields ------------------------------------------ */
  $('intro').textContent = cfg.intro;

  /* The inches under the size buttons. Shared with the artwork form,
     because both kinds of product page have the same problem. */
  if (window.MWSizeNote) MWSizeNote.mountWhenReady(cfg.sizes);

  /* DROPDOWNS — for a choice with too many answers to be buttons.

     The state board is the case: fifty states. It is not a Shopify
     option, because fifty states times four materials would be two
     hundred variants for a choice that does not move the price by a
     cent. It rides along as a line-item property, like the words do,
     and `MWCart.props` already knows how to read a <select>. */
  $('selects').innerHTML = (cfg.selects || []).map(function (sel) {
    return '<div class="mw-field"><label for="mw-' + sel.id + '">' + esc(sel.label) + '</label>' +
      '<select id="mw-' + sel.id + '" data-select="' + sel.id + '" data-prop="' + esc(sel.prop) + '">' +
      sel.options.map(function (o) {
        return '<option' + (o === sel.value ? ' selected' : '') + '>' + esc(o) + '</option>';
      }).join('') + '</select>' +
      (sel.note ? '<p class="mw-note">' + esc(sel.note) + '</p>' : '') +
      '</div>';
  }).join('');

  $('fields').innerHTML = cfg.fields.map(function (f) {
    return '<div class="mw-field">' +
      '<label for="mw-' + f.id + '">' + esc(f.label) +
      (f.optional ? ' <span class="mw-hint">— optional</span>' : '') + '</label>' +
      '<input type="text" id="mw-' + f.id + '" data-field="' + f.id + '" data-prop="' + esc(f.prop) + '"' +
      ' maxlength="' + f.max + '" placeholder="' + esc(f.placeholder || '') + '" autocomplete="off">' +
      '<p class="mw-note"><span data-count="' + f.id + '">0</span> of ' + f.max + ' characters</p>' +
      '</div>';
  }).join('');

  /* Some products sell the lettering as a real choice — the word cutout
     is CUT in that face, so it is a Shopify option with its own variant.
     There must still be only ONE control for it, or a customer ends up
     ordering block and being shown script.

     David, 2026-10-01: the choice belongs here, beside the sample, not
     up in the option buttons where the preview is out of sight. So the
     panel draws the picker, and Horizon's own Lettering buttons are
     hidden — but only once this has rendered (the `mw-lettering-moved`
     class), so if the script fails the theme's buttons are still there.
     Picking a face here presses the matching hidden button, and the
     variant that goes to the cart is worked out from THIS choice rather
     than read back from the theme, which redraws a moment later. */
  var letterIndex = -1;
  (map.optionNames || []).forEach(function (n, i) {
    if (letterIndex === -1 && /letter/i.test(n)) letterIndex = i;
  });
  var letteringIsVariant = letterIndex !== -1;
  var pendingLetter = null;

  function faceFor(value) {
    for (var k = 0; k < cfg.fonts.length; k++) {
      if (cfg.fonts[k].label.toLowerCase() === String(value).toLowerCase()) return cfg.fonts[k];
    }
    return cfg.fonts[0];
  }

  function faceButton(value, label, f, checked, prop) {
    return '<label class="mw-font"><input type="radio" name="mw-font" value="' + esc(value) + '"' +
      (prop ? ' data-prop="Lettering" data-label="' + esc(label) + '"' : '') + (checked ? ' checked' : '') + '>' +
      '<span class="mw-font__face" style="font-family:' + f.css + ';font-weight:' + f.weight +
      (f.upper ? ';text-transform:uppercase' : '') + '">' + esc(label) + '</span></label>';
  }

  if (letteringIsVariant) {
    var letterValues = [];
    map.variants.forEach(function (v) {
      var val = v.options[letterIndex];
      if (letterValues.indexOf(val) === -1) letterValues.push(val);
    });
    var current = themeVariant().options[letterIndex];
    $('lettering').innerHTML =
      '<div class="mw-field"><span class="mw-label">Lettering</span><div class="mw-fonts">' +
      letterValues.map(function (val) {
        return faceButton(val, val, faceFor(val), val === current, false);
      }).join('') + '</div>' +
      '<p class="mw-note">The machine cuts the word in this face, so the sample beside it is the shape you get.</p></div>';
    document.documentElement.classList.add('mw-lettering-moved');
  } else {
    $('lettering').innerHTML =
      '<div class="mw-field"><span class="mw-label">Lettering</span><div class="mw-fonts">' +
      cfg.fonts.map(function (f, i) {
        return faceButton(f.id, f.label, f, i === 0, true);
      }).join('') + '</div></div>';
  }

  var addonHtml = cfg.addons.map(function (a, i) {
    var field = a.field
      ? '<div class="mw-field mw-addon__field" data-addon-field="' + i + '" hidden>' +
        '<input type="text" id="mw-addon-' + i + '" data-prop="' + esc(a.field.prop) + '"' +
        ' maxlength="' + a.field.max + '" placeholder="A dedication, a date, a line from whoever gave it">' +
        '</div>' : '';
    return '<label class="mw-addon"><input type="checkbox" data-addon="' + i + '"' +
      ' data-prop="' + esc(a.label) + '" data-label="Yes">' +
      '<span class="mw-addon__text"><b>' + esc(a.label) + '</b> ' + money(a.price) +
      (a.note ? '<em>' + esc(a.note) + '</em>' : '') + '</span></label>' + field;
  }).join('');
  /* No extras on this product — then no heading either. An empty
     "Add to it" with nothing under it reads like something failed. */
  $('addons').innerHTML = cfg.addons.length
    ? '<div class="mw-field"><span class="mw-label">Add to it</span>' + addonHtml + '</div>'
    : '';

  /* ---- solid surface: a Corian colour, and a colour for the fill ----
     David, 2026-10-04: choosing Solid surface is only half a choice —
     the sheet comes in a hundred colours and the engraving is filled
     in another. So when the material is solid surface, two required
     fields appear, and a button opens Corian's own North American
     colour portfolio in a pop-up to look through first.

     The guide is Corian's published leaflet, embedded from corian.com
     rather than copied here, so it is always their current one. The
     names below come from that leaflet (2024 edition) and only feed
     the field's suggestions; any name can be typed. */
  var CORIAN_GUIDE = 'https://www.corian.com/sites/corian.com/IMG/pdf/2024_ss_na_colorportfolio_leaflet.pdf';
  var CORIAN_TOOL = 'https://www.colors.corian.com/';
  var CORIAN_NAMES = ['Abalone', 'Antarctica', 'Arctic Ice', 'Arrowroot', 'Artista Beige', 'Artista Canvas',
    'Artista Dust', 'Artista Gray', 'Artista Mist', 'Artista Sage', 'Ash Aggregate', 'Ash Concrete', 'Aurora',
    'Bisque', 'Bleached Nuwood', 'Bone', 'Calacatta Greige', 'Cameo White', 'Canvas', 'Canyon', 'Carbon Aggregate',
    'Carbon Concrete', 'Carrara Crema', 'Carrara Lino', 'Cirrus White', 'Clam Shell', 'Concrete', 'Cosmos Prima',
    'Deep Anthracite', 'Deep Black Quartz', 'Deep Cloud', 'Deep Espresso', 'Deep Mink', 'Deep Night Sky',
    'Deep Nocturne', 'Deep Sable', 'Deep Storm', 'Deep Titanium', 'Designer White', 'Doeskin', 'Domino Terrazzo',
    'Dove', 'Dune Prima', 'Elegant Gray', 'Evening Prima', 'Everest', 'Excavage', 'Glacier Ice', 'Glacier White',
    'Gray Onyx', 'Hazelnut', 'Hot', 'Juniper', 'Laguna', 'Laguna Terrazzo', 'Lava Rock', 'Limestone Prima', 'Linen',
    'Matterhorn', 'Modern White', 'Natural Gray', 'Neutral Aggregate', 'Neutral Concrete', 'Nimbus Prima',
    'Pearl Gray', 'Pebble Lane', 'Peppered Terrazzo', 'Platinum', 'Provence Nuwood', 'Rain Cloud', 'Rice Paper',
    'Rosemary', 'Sagebrush', 'Sahara', 'Sandalwood', 'Sandstone', 'Sandstorm', 'Savannah', 'Sepia Linear',
    'Serene Sage', 'Silt', 'Silver Birch', 'Silver Gray', 'Silver Linear', 'Silverite', 'Smoke Drift Prima',
    'Sorrel', 'Sparkling Granita', 'Sparkling White', 'Stonecrest Smoke', 'Stonique', 'Vanilla', 'Venaro White',
    'Verdant', 'Weathered Aggregate', 'Weathered Concrete', 'Whipped Cream', 'Whisper', 'White Jasmine',
    'White Onyx', 'Willow', 'Windswept Prima', 'Witch Hazel'];

  var solidSlot = $('solid');
  if (!solidSlot) {                       /* older section markup: make the slot */
    solidSlot = document.createElement('div');
    solidSlot.setAttribute('data-mw', 'solid');
    var afterSel = $('selects');
    afterSel.parentNode.insertBefore(solidSlot, afterSel.nextSibling);
  }
  solidSlot.hidden = true;
  solidSlot.innerHTML =
    '<div class="mw-field mw-solid">' +
      '<label for="mw-solid-color">Solid surface color</label>' +
      '<div class="mw-solid__row">' +
        '<input type="text" id="mw-solid-color" data-solid="color" data-prop-name="Solid surface color"' +
        ' list="mw-corian-names" autocomplete="off" placeholder="A Corian color, e.g. Rain Cloud">' +
        '<button type="button" class="mw-solid__browse" data-mw-open-guide>Browse the Corian colors</button>' +
      '</div>' +
      '<datalist id="mw-corian-names">' + CORIAN_NAMES.map(function (n) {
        return '<option value="' + esc(n) + '"></option>';
      }).join('') + '</datalist>' +
    '</div>' +
    '<div class="mw-field">' +
      '<label for="mw-solid-fill">Fill color <span class="mw-hint">— the color inside the engraving</span></label>' +
      '<input type="text" id="mw-solid-fill" data-solid="fill" data-prop-name="Fill color"' +
      ' autocomplete="off" placeholder="e.g. white, black, gold">' +
      '<p class="mw-note">I confirm both colors with you on the proof, before anything is cut.</p>' +
    '</div>';

  var guide = null;
  function openGuide() {
    if (!guide) {
      guide = document.createElement('dialog');
      guide.className = 'mw-guide';
      guide.setAttribute('aria-label', 'Corian color guide');
      guide.innerHTML =
        '<div class="mw-guide__head">' +
          '<h2 class="mw-guide__title">Corian color guide</h2>' +
          '<button type="button" class="mw-guide__close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<iframe class="mw-guide__frame" title="Corian solid surface North American color portfolio"></iframe>' +
        '<div class="mw-guide__foot">' +
          '<p>Corian\'s own North American color portfolio. Screens and print both shift color a little, so I ' +
          'confirm yours on the proof before cutting.</p>' +
          '<p class="mw-guide__links"><a href="' + CORIAN_GUIDE + '" target="_blank" rel="noopener">Open the guide in a new tab</a>' +
          ' · <a href="' + CORIAN_TOOL + '" target="_blank" rel="noopener">Corian\'s color tool, with full-sheet photos</a></p>' +
        '</div>';
      document.body.appendChild(guide);
      guide.querySelector('.mw-guide__close').addEventListener('click', function () { guide.close(); });
      guide.addEventListener('click', function (e) { if (e.target === guide) guide.close(); });
    }
    var frame = guide.querySelector('iframe');
    if (!frame.getAttribute('src')) frame.setAttribute('src', CORIAN_GUIDE + '#page=2&view=FitH');
    if (guide.showModal) guide.showModal(); else window.open(CORIAN_GUIDE, '_blank', 'noopener');
  }
  solidSlot.addEventListener('click', function (e) {
    if (e.target.closest('[data-mw-open-guide]')) openGuide();
  });

  function isSolid(variant) {
    return variant.options.some(function (o) { return /solid surface/i.test(String(o)); });
  }

  /* Shown only for solid surface. The fields carry their property name in
     data-prop-name and only get data-prop (what the cart reads) while
     visible, so a colour typed and then abandoned for maple never
     reaches the order. */
  function syncSolid(variant) {
    var on = isSolid(variant);
    solidSlot.hidden = !on;
    [].forEach.call(solidSlot.querySelectorAll('[data-solid]'), function (el) {
      if (on) el.setAttribute('data-prop', el.getAttribute('data-prop-name'));
      else el.removeAttribute('data-prop');
    });
    return on;
  }

  /* ---- the selected variant, straight from the theme -------------- */
  function themeVariant() {
    var input = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')
      || document.querySelector('input[name="id"]');
    var id = input ? Number(input.value) : Number(new URL(location.href).searchParams.get('variant'));
    for (var i = 0; i < map.variants.length; i++) {
      if (map.variants[i].id === id) return map.variants[i];
    }
    return map.variants[0];
  }

  /* The theme's variant, with the lettering the panel shows swapped in.
     Size and finish still come from the theme's buttons; the face comes
     from the panel, so the cart never lags behind the sample. */
  function panelLetter() {
    var picked = letteringIsVariant && root.querySelector('input[name="mw-font"]:checked');
    return picked ? picked.value : null;
  }

  function selectedVariant() {
    var base = themeVariant();
    var letter = panelLetter();
    if (!letter || base.options[letterIndex] === letter) return base;
    for (var i = 0; i < map.variants.length; i++) {
      var v = map.variants[i];
      var same = v.options[letterIndex] === letter && v.options.every(function (o, k) {
        return k === letterIndex || o === base.options[k];
      });
      if (same) return v;
    }
    return base;
  }

  /* Press the theme's own (hidden) button for this face, so Horizon's
     variant, URL and photographs follow the panel. */
  function pushLetter(value) {
    pendingLetter = value;
    var radios = document.querySelectorAll('variant-picker input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) { if (!radios[i].checked) radios[i].click(); return; }
    }
    var selects = document.querySelectorAll('variant-picker select');
    for (var s = 0; s < selects.length; s++) {
      for (var o = 0; o < selects[s].options.length; o++) {
        if (selects[s].options[o].value === value && selects[s].value !== value) {
          selects[s].value = value;
          selects[s].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }
  }

  /* The other way: the theme's variant changed under us (a ?variant=
     link, the back button). Follow it — unless it is still catching up
     with a face the customer has just picked here. */
  function pullLetter() {
    if (!letteringIsVariant) return;
    var themeLetter = themeVariant().options[letterIndex];
    if (pendingLetter !== null) {
      if (themeLetter === pendingLetter) pendingLetter = null;
      return;
    }
    var radios = root.querySelectorAll('input[name="mw-font"]');
    for (var i = 0; i < radios.length; i++) radios[i].checked = radios[i].value === themeLetter;
  }

  /* the dimension for whichever option value is the size */
  function dimFor(variant) {
    if (!cfg.sizes) return '';
    for (var i = 0; i < cfg.sizes.length; i++) {
      if (variant.options.indexOf(cfg.sizes[i].value) !== -1) return cfg.sizes[i].dim;
    }
    return '';
  }

  function fieldValue(id) {
    var el = root.querySelector('[data-field="' + id + '"]');
    return el ? el.value.trim() : '';
  }

  function typedText() {
    return cfg.fields.map(function (f) { return fieldValue(f.id); }).filter(Boolean).join(' ');
  }

  /* ---- what has been chosen, and what it costs -------------------- */
  function chosen() {
    var variant = selectedVariant();
    var dim = dimFor(variant);
    /* What the customer picked in a dropdown is part of what they are
       buying, so it belongs on the line they are looking at — not only
       in the properties that reach the order. */
    var picked = (cfg.selects || []).map(function (sel) {
      var el = root.querySelector('[data-select="' + sel.id + '"]');
      return el ? el.value : '';
    }).filter(Boolean);

    var lines = [{
      label: picked.concat(variant.options).join(' / ') + (dim ? ' — ' + dim : ''),
      price: variant.price,
    }];
    var text = typedText();

    if (cfg.engraving && text) {
      lines.push({ label: cfg.engraving.label, price: cfg.engraving.fee, addon: cfg.engraving.label });
    }

    if (cfg.extraChar) {
      var over = Math.max(0, text.replace(/\s/g, '').length - cfg.extraChar.after);
      if (over) {
        lines.push({
          label: over + ' extra letter' + (over === 1 ? '' : 's'),
          price: over * cfg.extraChar.fee,
          addon: 'Extra letter over six', qty: over,
        });
      }
    }

    cfg.addons.forEach(function (a, i) {
      var box = root.querySelector('[data-addon="' + i + '"]');
      if (box && box.checked) lines.push({ label: a.label, price: a.price, addon: a.label });
    });

    return { variant: variant, lines: lines, total: lines.reduce(function (s, l) { return s + l.price; }, 0), text: text };
  }

  /* ---- the sample ------------------------------------------------- */
  function font() {
    if (letteringIsVariant) return faceFor(selectedVariant().options[letterIndex]);
    var picked = root.querySelector('input[name="mw-font"]:checked');
    var name = picked ? picked.value : cfg.fonts[0].id;
    for (var i = 0; i < cfg.fonts.length; i++) if (cfg.fonts[i].id === name) return cfg.fonts[i];
    return cfg.fonts[0];
  }

  function render() {
    var f = font();
    var l1 = $('sample-l1'), l2 = $('sample-l2');
    var values = cfg.fields.map(function (x) { return fieldValue(x.id); });

    [l1, l2].forEach(function (el) {
      if (!el) return;
      el.style.fontFamily = f.css;
      el.style.fontWeight = f.weight;
      el.style.textTransform = f.upper ? 'uppercase' : 'none';
    });
    if (l1) l1.textContent = values[0] || (cfg.fields[0] && cfg.fields[0].placeholder) || '';
    if (l1) l1.classList.toggle('is-placeholder', !values[0]);
    if (l2) l2.textContent = values[1] || '';

    cfg.fields.forEach(function (x) {
      var c = root.querySelector('[data-count="' + x.id + '"]');
      if (c) c.textContent = String(fieldValue(x.id).length);
    });

    /* a field that belongs to an add-on only shows when it is ticked,
       and the material-specific extras only when that material is on */
    cfg.addons.forEach(function (a, i) {
      var box = root.querySelector('[data-addon="' + i + '"]');
      var extra = root.querySelector('[data-addon-field="' + i + '"]');
      if (extra && box) extra.hidden = !box.checked;
      if (a.onlyWhen && box) {
        var fits = selectedVariant().options.indexOf(a.onlyWhen) !== -1;
        var label = box.closest('.mw-addon');
        if (label) label.hidden = !fits;
        if (!fits && box.checked) box.checked = false;
      }
    });

    var state = chosen();
    $('total').textContent = money(state.total);
    $('breakdown').innerHTML = state.lines.map(function (l) {
      return '<li><span>' + esc(l.label) + '</span><span>' + money(l.price) + '</span></li>';
    }).join('');
    /* Everything sold here is made to order now (David, 2026-10-03), so the
       panel no longer promises a ready-to-ship time before words are typed. */
    $('lead').textContent = map.leadTimes.made;

    /* The one hard rule kept from the old configurator: a required
       field is required, and the button says why it is off. */
    var missing = cfg.fields.filter(function (x) { return !x.optional && !fieldValue(x.id); })
      .map(function (x) { return x.label.split('—')[0].trim().toLowerCase(); });
    if (syncSolid(state.variant)) {
      [].forEach.call(solidSlot.querySelectorAll('[data-solid]'), function (el) {
        if (!el.value.trim()) missing.push(el.getAttribute('data-prop-name').toLowerCase());
      });
    }
    var btn = document.getElementById('addBtn');
    if (btn) {
      btn.disabled = missing.length > 0;
      $('validation').textContent = missing.length ? 'Add ' + missing[0] + ' to continue.' : '';
    }
    return state;
  }

  root.addEventListener('input', render);
  root.addEventListener('change', function (e) {
    if (letteringIsVariant && e.target && e.target.name === 'mw-font') pushLetter(e.target.value);
    render();
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') render();      /* variant picked */
  });
  /* Horizon swaps the variant field without firing an event the panel
     can see, so the value is watched directly. Cheap, and it keeps the
     total honest when someone changes the wood. */
  var lastVariant = null;
  setInterval(function () {
    var v = themeVariant();
    if (v && v.id !== lastVariant) { lastVariant = v.id; pullLetter(); render(); }
  }, 400);

  document.getElementById('addBtn').addEventListener('click', function () {
    var state = render();
    if (document.getElementById('addBtn').disabled) return;

    var props = window.MWCart ? MWCart.props(root) : [];
    MW.addToCart({
      sku: handle,
      name: map.title,
      unit: state.total,
      props: props,
      /* the panel knows exactly which add-ons were chosen, so the cart
         does not have to infer them from the form */
      addons: state.lines.filter(function (l) { return l.addon; })
        .map(function (l) { return { label: l.addon, qty: l.qty || 1 }; }),
      variantId: state.variant.id,
    });
  });

  render();
})();
